import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import PortfolioDrilldownPage from '@/pages/PortfolioDrilldownPage';
import HeatmapPage from '@/pages/HeatmapPage';
import RiskMapPage from '@/pages/RiskMapPage';
import TerritoryPage from '@/pages/TerritoryPage';
import BrokerScorecardPage from '@/pages/BrokerScorecardPage';
import AppetiteAnalyticsPage from '@/pages/AppetiteAnalyticsPage';
import ConcentrationPage from '@/pages/ConcentrationPage';
import LossWatchlistPage from '@/pages/LossWatchlistPage';
import GeoExposurePage from '@/pages/GeoExposurePage';
import CapacityGatePage from '@/pages/CapacityGatePage';

export default function PortfolioModule() {
  const tabs = [
    { id: 'overview', label: 'Overview', content: <PortfolioDrilldownPage /> },
    { id: 'concentration', label: 'Concentration', content: <ConcentrationPage /> },
    { id: 'watchlist', label: 'Watchlist', content: <LossWatchlistPage /> },
    { id: 'riskmap', label: 'Risk Map', content: <RiskMapPage /> },
    { id: 'geo', label: 'Geo Exposure', content: <GeoExposurePage /> },
    { id: 'capacity', label: 'Capacity Gate', content: <CapacityGatePage /> },
    { id: 'heatmap', label: 'Heatmap', content: <HeatmapPage /> },
    { id: 'territory', label: 'Territory', content: <TerritoryPage /> },
    { id: 'brokers', label: 'Brokers', content: <BrokerScorecardPage /> },
    { id: 'appetite', label: 'Appetite', content: <AppetiteAnalyticsPage /> },
  ];

  return (
    <ModuleShell title="Portfolio" subtitle="Cross-module aggregate intelligence" tabs={tabs} />
  );
}
